// ABOUTME: The orientation's schedule-session button: the Nylas slot picker for a one-on-one
// ABOUTME: participant whose coach books through Nylas, otherwise the FreeBusy booking
import { just } from 'maybeasy';
import { observer } from 'mobx-react';
import * as React from 'react';
import { findLink } from '../../../../../LinkyLinky';
import CoachingScheduler from '../../../../CoachingScheduler';
import ScheduleButtonView from './ScheduleButtonView';
import ScheduleSessionReady from './ScheduleSessionReady';

type Props = React.ComponentProps<typeof ScheduleSessionReady>;

// FreeBusy is not loaded at all when the participant books through the slot picker.
const ScheduleSessionEntry: React.FC<Props> = (props) =>
  findLink('coaching-scheduler', props.scheduleSessionResource.links)
    .map((schedulerLink) => (
      <CoachingScheduler
        key={schedulerLink.href}
        purpose="book"
        schedulerLink={schedulerLink}
        participantEmail={just(props.scheduleSessionResource.payload.proposerParticipant.email)}
        onBooked={props.scheduleSessionStore.reloading}
      >
        {(open) => (
          <ScheduleButtonView
            buttonId="coaching-scheduler-orientation-button"
            disabled={false}
            onClick={open}
          />
        )}
      </CoachingScheduler>
    ))
    .getOrElse(() => <ScheduleSessionReady {...props} />);

export default observer(ScheduleSessionEntry);
